import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MasterHome from "./shared/modules/admin/MasterHome";
import { GetConfigurationPageSetup } from "./shared/services/services";
import { useUser } from "./business-types/grocery/components/UserContext";
import Signup from "./features/auth/pages/Signup";
import GroceryNavigations from "./shared/routes/GroceryNavigations";
import Login from "./shared/modules/admin/auth/Login";
import SetPassword from "./shared/modules/admin/SetPassword";
import ForgotPassword from "./shared/modules/admin/ForgotPassword";
import ResetPassword from "./shared/modules/admin/ResetPassword";
import { errorHandling } from "./shared/utils/errorHandling";
import NotFound from "./shared/modules/admin/NotFound";
import ErrorBoundary from "./shared/components/ErrorBoundary";
import ProtectedRoutes from "./shared/routes/ProtectedRoutes";
import useUsers from "./business-types/grocery/hooks/useUsers";



export const basepath = process.env.REACT_APP_BASEPATH;



const App: React.FC = () => {
  const [employee, setEmployee] = useState<boolean>(false);
  const { setUser, setConfigurations } = useUser();
  const { reload } = useUsers()

  useEffect(() => {
    const employeeLogin = sessionStorage.getItem("employee");
    const employeeData = sessionStorage.getItem("Noemployee");
    if (employeeLogin) setEmployee(true);
    else if (employeeData) setEmployee(false);
  }, []);

  const tokenValid = !!sessionStorage.getItem("jsonwebtoken");

  useEffect(() => {
    if (!tokenValid) return;
    reload()

    GetConfigurationPageSetup()
      .then((res) => {
        const useConfig = res?.data?.result?.[0];
        if (useConfig) setConfigurations(useConfig);
      })
      .catch((error) => errorHandling(error));

  }, [tokenValid]);



  return (
    <BrowserRouter basename={basepath}>
      <ErrorBoundary>
        <Routes>
          <Route path='/' element={<Login />} />
          <Route path='/imetanic/setpassword/:userid/:expiryTime/2580' element={<SetPassword />} />
          <Route path='/sign-up' element={<Signup />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          <Route path='/reset-password/:token' element={<ResetPassword />} />
          <Route path='/v1/*' element={<ProtectedRoutes />} />
          <Route path='/master-home' element={<MasterHome />} />
          <Route path={`/grocery/V2/*`} element={<GroceryNavigations />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default App;
